<div class="dialog">
  <div mat-dialog-content>
    <div class="dialog-message">{{ 'workOrderFeedback.noRecipientConfirm.title' | translate }}</div>
    <div class="dialog-confirm-message">{{ 'workOrderFeedback.noRecipientConfirm.description' | translate }}</div>
  </div>
  <div class="dialog-actions">
    <button mat-stroked-button mat-dialog-close>
      {{ 'components.confirm.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
      {{ 'workOrderFeedback.noRecipientConfirm.saveAnyway' | translate }}
    </button>
  </div>
</div>
